import { ChevronRight, Newspaper } from 'lucide-react';
import { Link } from 'react-router-dom';

export function UndergraduateNewsLink() {
  return (
    <section className="undergraduate-news-link" aria-labelledby="undergraduate-news-heading">
      <Link to="/news?category=undergraduate" className="undergraduate-news-link__body">
        <span className="undergraduate-news-link__icon" aria-hidden="true">
          <Newspaper size={23} />
        </span>
        <span className="undergraduate-news-link__copy">
          <strong id="undergraduate-news-heading">Thông tin tuyển sinh đại học</strong>
          <span>Cập nhật phương thức, chỉ tiêu và thời gian tuyển sinh từ nguồn chính thức.</span>
        </span>
        <ChevronRight className="undergraduate-news-link__arrow" size={20} aria-hidden="true" />
      </Link>
    </section>
  );
}
